import React from "react";
import Noimg from "../../../../images/noimg.png";
import BaseLinkButton from "../../../components/Common/Buttons/BaseLinkButton";
import Layout from "../../../components/Common/Layout";

type Props = {};

const Completion: React.FC<Props> = (props) => {
  return (
    <Layout
      breadcrumbs={[
        {
          text: "HOME",
          href: "/",
        },
        {
          text: "本登録完了",
        }
      ]}
    >
      <section className="mt-[40px] px-[30px] sm:max-w-main sm:mb-[40px] sm:mt-[60px] sm:mx-auto">
        <h1 className="mb-[30px] sm:mb-[60px] text-lg font-bold sm:text-2xl">
          本登録が完了しました
        </h1>
        <div className="sm:w-[700px] sm:mx-auto">
          <div className="mb-[45px] sm:mb-[60px] sm:text-center leading-loose">
            <p>Spportunityへの本登録が完了しました。</p>
            <p>引き続きサービスをお楽しみください。</p>
          </div>
          <div className="w-[143px] h-[110px] mx-auto">
            <img src={Noimg} alt="" />
          </div>
          <div className="mt-[60px] mx-auto h-[50px] sm:w-[360px]">
            <BaseLinkButton
              text="トップページへ"
              link="/"
            />
          </div>
        </div>
      </section>
    </Layout>
    
  );
};

export default Completion;
